import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {environment} from 'src/environments/environment';
import {Subscription} from "rxjs";
import {TenantService} from "./pages/landing/services/tenant.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service";
import {AuthTokenService} from "./shared/services/token.service";
import {MainDataService} from "./shared/services/main-data.service";
import {StoreService} from "./shared/services/store.service";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "./shared/services/auth.service";
import {AppDataService} from "./shared/services/app-data.service";
import { LoaderService } from './shared/services/loader.service';

declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  @ViewChild('scroll', {read: ElementRef}) public scroll!: ElementRef<any>;

  showTenantSelection: any = [];
  tenantId: any;
  title: string = 'Yalla Mall';
  tenantSubscription: Subscription;
  showHeader: boolean = false;
  initializeApp: boolean = false;
  waitForTenantSubscription: boolean = false;
  token: any;
  maintenanceMode: boolean = false;
  isLoading:boolean = true

  constructor(
    private appTitle: Title,
    private tenantService: TenantService,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService,
    private authTokenService: AuthTokenService,
    private store: StoreService,
    private mainDataService: MainDataService,
    private http: HttpClient,
    private authService: AuthService,
    private appDataService: AppDataService
  ) {
    this.http.get<any>('assets/data.json').subscribe(data => {
      this.maintenanceMode = data.maintenanceMode
        $('body').addClass('storecloud');
      //remove to force tenant 3
      //localStorage.setItem('tenantId', environment.defaultTenant)
      if (!this.maintenanceMode) this.loadApp()
      this.cd.detectChanges()
      this.isLoading = false
      //this.cd.detectChanges()
    });

    // if (environment.isStoreCloud) {
    //   $('body').addClass('storecloud');
    //   localStorage.setItem('tenantId', environment.defaultTenant)
    // }

    appTitle.setTitle(this.title);
    this.tenantId = localStorage.getItem('tenantId')
if(!this.tenantId){
  this.tenantId = environment.defaultTenant
  localStorage.setItem('tenantId', this.tenantId);
}

  }


  ngOnInit() {
    // this.loadAppData()
  }

 
  loadApp() {

    this.activatedRoute.queryParams.subscribe(queryParams => {
      if (queryParams.tenantId) {
        this.tenantId = queryParams.tenantId || environment.defaultTenant
        localStorage.setItem('tenantId', this.tenantId)
        this.waitForTenantSubscription = true
        if (this.cookieService.get('authToken')) {
          // TODO: commented this logout because on every page refresh user get logged out
          // this.logOut()
          this.loadAppData()
        } else {
          this.loadAppData()
        }
      } else {
        setTimeout(() => {
          if (!this.waitForTenantSubscription) {
            this.loadAppData()
          }
        }, 500)
      }

    });
    this.tenantSubscription = this.tenantService.getTenant()
      .subscribe(response => {

        this.tenantId = response
        localStorage.setItem('tenantId', this.tenantId)
        this.loadAppData()
      })

    this.tenantService.getHeader()
      .subscribe((resp: any) => {
        this.showHeader = resp
      })
  }

  scrollToTop() {
    this.scroll.nativeElement.scrollTop = 0;
  }

  async loadAppData() {
    if (!this.authService.isMarketplace()) {
      await this.authService.getShopSettingsData().subscribe({
        next: (res: any) => {
          if(res.data) {
            this.appDataService.shopSettingData = res.data
            this.cd.detectChanges()
          }
        }
      })
    }
    if (this.tenantId !== null && this.tenantId !== '' && this.tenantId != undefined) {
      await this.tenantService.getAppConfigurationData();
      this.initializeApp = true
      this.cd.detectChanges()
    }
  }

  ngOnDestroy() {
    this.tenantSubscription.unsubscribe();
  }

  logOut() {
    this.authTokenService.callLogout().subscribe({
      next: (res: any) => {},
      error: (err)=> {}
    });
    sessionStorage.clear();
    this.authTokenService.authTokenSet('');

    this.cookieService.delete('authToken', '/');
    this.store.set('profile', '');
    this.mainDataService.setCartLenghtData(null);
    this.mainDataService.setUserData(null);

    localStorage.setItem('sessionId', '');
    localStorage.setItem('addedProducts', '');
    localStorage.setItem('cartId', '');
    this.store.set('cartProducts', []);
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('auth_enc');
  }
}
